module.exports = __webpack_public_path__ + "img/amex.587e46e8.png";